export const ALLOWED_REDIRECT_TLD = process.env.REACT_APP_ALLOWED_REDIRECT_TLD?.split(",") ?? [];

export default function isAllowedRedirect(raw: string) {
    if (raw.startsWith("/")) {
        return true;
    }
    const url = new URL(raw);
    return ALLOWED_REDIRECT_TLD.some(domain => url.host.endsWith(domain));
}
